import React, { useRef } from 'react'
import filter from '../assets/images/filter_black.png'

export default function Filter(props) {
    const handleFilter = (e) => {
        e.stopPropagation();
        if (props.filterRef.current.style.display === "none") {
            props.filterRef.current.style.display = "block";
        } else {
            props.filterRef.current.style.display = "none";
        }
    }
    // const handleFilterValue =  async (value) => {
    //     console.log("filter value = ", value);
    //     if(value === "parked"){
    //       console.log("Inside park");
    //        const response = await vinsParkedStatusAPI("True");
    //        console.log("parked",response)
    //        dispatch(VinParkedStatus(response.data.data.vehicle_detail));
    //     }
    //     else if(value === "non_parked")
    //     {
    //         const response = await vinsParkedStatusAPI("False");
    //         console.log("parked",response)
    //         dispatch(VinParkedStatus(response.data.data.vehicle_detail));
    //     }
    // }

    // const [filterOptions, setFilterOptions] = useState([
    //     { value: "parked", label: "Parked" },
    //     { value: "non_parked", label: "Non Parked" }
    // ])

    const showFilter = useRef(0)
    // window.onclick = function (event) {
    //     event.stopPropagation();
    //     console.log("inside", showFilter.current.style.display)
    //     showFilter.current.style.display = "none";
    // }

    // console.log("props of filter",props);
    return (

        <>
            <img src={filter} alt="filter" onClick={(e) => { handleFilter(e) }} style={{ width: "1.25rem", height: "1.25rem", cursor: "pointer", zIndex: '3' }} />
            <div className="filter-container" ref={props.filterRef} style={{ display: "none" }}>
                {props?.header?.map((option,index) => {
                    // console.log("option",option)
                    return (
                        <div className="filter-inner-container smallFont" key={`filter_${index}`}>
                            <input onClick={handleFilter} onChange={() => { props.handleFilterValue(option.value, props.filterRef) }} name="location" type="radio" value={option.value} id={option.label} />
                            <label htmlFor={option.label}>{option.label}</label>
                        </div>
                    )
                })}
            </div>
            <style>
                {`
                .filter-container{
                    z-index: 2;
                    display: none;
                    position: absolute;
                    top: 40px;
                    right: -10px;
                    white-space: nowrap;
                    /* border-top: solid 15px transparent; */
                    background: #FFFFFF;
                    box-shadow: 0 0 0.5rem rgba(0, 0, 39, 0.15);
                    border-radius: 0.5rem;
                    padding: 0 1rem 1rem;
                }
                .filter-inner-container{
                    display: flex;
                    font-weight: 600;                    
                    line-height: 19px;
                    gap: 1rem;
                    margin-top: 1rem;
                }
                .filter-container:before,
                .filter-container:after {
                    content: '';
                    position: absolute;
                    bottom: 100%;
                    right: 10px;
                    border: 11px solid transparent;
                    border-bottom-color: #dddddd;
                }
                
                .filter-container:after {
                    right: 11px;
                    border: 10px solid transparent;
                    border-bottom-color: #ffffff;
                }
        `}
            </style>
        </>
    )
}